import { combineEpics } from 'redux-observable';
import { createStore } from './createStore';
import { createMarket } from './createMarket';

export default combineEpics(createStore, createMarket);



// WEBPACK FOOTER //
// ./src/scenes/CreateStore/services/epics/index.ts